import { DeletableItemDisplayText } from 'ui/indexPages/modals/DeleteItemsModal';
import { useTranslation } from 'modules/domains/list';
import { Delete } from 'ui/icons';

export const useDeleteListModalDisplayText = (): DeletableItemDisplayText => {
  const { t } = useTranslation();
  return {
    actionName: {
      adjective: t('indexPage.modals.deleteList.displayText.adjective'),
      verb: t('indexPage.modals.deleteList.displayText.verb'),
    },
    itemTypeName: {
      plural: t('indexPage.modals.deleteList.displayText.plural'),
      singular: t('indexPage.modals.deleteList.displayText.singular'),
    },
    actionIcon: Delete,
  };
};
